"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

exports.mapWishlist = mapWishlist;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapWishlist(wishlists) {
  return {
    wishlists: wishlists,
    isWishlisted: wishlists.reduce(function (prev, curr) {
      return (0, _extends4.default)({}, prev, (0, _defineProperty3.default)({}, curr._id, { state: true, loading: false }));
    }, {})
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/wishlist.js
// module id = 1710
// module chunks = 47